import React, { useState } from 'react';
// import RequestSuccess from '../../loaders/requestSuccess';
import { useSelector } from 'react-redux';
import GenericFormHeaderComponent from '../../../genericComponents/forms/GenericFormHeaderComponent';
import Icons from '../../../assets/icons';
import useCustomToast from '../../../hooks/useCustomToast';
import '../../../styles/stylesheets/Administration/DetailsLog.scss';

const DetailApiLog = ({ selectedData, closeModal }) => {
    const apiId = selectedData.id

    const [isCopySuccess, setIsCopySuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");

    const administrationStore = useSelector(state => state.administrationStore)
    const generalStore = useSelector((state) => state.generalStore)
    const customToast = useCustomToast()

    const getModuleApiDisplayData = generalStore?.getTableComponentListData?.data?.resource?.filter(item => item.id === apiId);

    const copyToClipboard = (textId) => {
        const el = document.getElementById(textId);
        var textArea = document.createElement("textarea");
        textArea.value = el.textContent;
        document.body.appendChild(textArea);  
        textArea.select()
        document.execCommand("copy")
        document.body.removeChild(textArea);
        setIsCopySuccess(true);
        setSuccessMessage("Text copied successfully");
        setTimeout(() => {
            setIsCopySuccess(false) 
        }, 3000)
    }

    console.log("getModuleApiDisplayData", getModuleApiDisplayData);

    return (
        <>{getModuleApiDisplayData?.length !== 0 &&
            <div style={{ overflow: 'scroll',height:'100%' }} >
                <div className="modal-content manage-api-log-modal" >
                    <GenericFormHeaderComponent closeModal={closeModal} label={{ contentPrimary: 'API Name', contentSecondry: getModuleApiDisplayData[0]?.apiName }} />
                    <div className="malm-body">
                        <div className="malmb-inner">
                            <h3>API URL</h3>
                            <div className="malmb-item">
                                <span className="malmb-copy-icon" style={{ cursor: 'pointer' }} onClick={() => copyToClipboard("apiurl")}>
                                    <Icons.CopyIcon />
                                </span>
                                <span className="code" id="apiurl">{getModuleApiDisplayData[0]?.apiURL}</span>
                            </div>
                        </div>
                        <div className="malmb-inner">
                            <h3>Headers</h3>
                            <div className="malmb-item">
                                <span className="malmb-copy-icon" style={{ cursor: 'pointer' }} onClick={() => copyToClipboard("header")}>
                                    <Icons.CopyIcon />
                                </span>
                                <pre>
                                    <code id="header">{getModuleApiDisplayData[0]?.headers}</code>
                                </pre>
                            </div>
                        </div>
                        <div className="malmb-inner">
                            <h3>Request Payload</h3>
                            <div className="malmb-item pt-4">
                                <span className="malmb-copy-icon" style={{ cursor: 'pointer' }} onClick={() => copyToClipboard("reqpayload")}>
                                    <Icons.CopyIcon />
                                </span>
                                <pre>
                                    <code id="reqpayload">{getModuleApiDisplayData[0]?.requestPayload}</code>
                                </pre>
                            </div>
                        </div>
                        <div className="malmb-inner">
                            <h3>Response Payload</h3>
                            <div className="malmb-item pt-4">
                                <span className="malmb-copy-icon" style={{ cursor: 'pointer' }} onClick={() => copyToClipboard("respayload")}>
                                    <Icons.CopyIcon />
                                </span>
                                <pre>
                                    <code id="respayload">{getModuleApiDisplayData[0]?.responsePayload}</code>
                                </pre>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
}
            {
                isCopySuccess && customToast({
                    title: "Request Success",
                    description: successMessage,
                    status: "success",
                })
            }
        </>
    );
}
export default DetailApiLog;
